import { DialogType } from '../../../../../@types';
import FormModalLayout from '../../../../layouts/FormModalLayout';
import SelectorEditor from './selectors/SelectorEditor';
import { MarketPickerProvider, useMarketPicker } from './picker/MarketPickerContext';
import MarketPicker from './picker/MarketPicker';

const MarketTypeExclusionsDialog = () => {
  const { actions, meta } = useMarketPicker();

  return (
    <FormModalLayout
      label='Market exclusions'
      onSave={actions.save}
      onClose={meta.closeModal}
      showEditTabs={false}
      disableSubmit={meta.disableSave}
      titleAlign='center'
    >
      <SelectorEditor />
      <MarketPicker />
    </FormModalLayout>
  );
};

const MarketExclusionsForm = ({ closeModal }: DialogType) => (
  <MarketPickerProvider closeModal={closeModal}>
    <MarketTypeExclusionsDialog />
  </MarketPickerProvider>
);

export default MarketExclusionsForm;
